module.exports = __webpack_public_path__ + "static/media/workshop_draft_emptystate.26d0af12.svg";